import React, { useState } from "react";
import * as XLSX from "xlsx";
import { Download } from "lucide-react";

// As variantes dark mantem o contraste dos fundos, textos e controles.
export default function ExportButton({ dados = [] }) {
  const [loading, setLoading] = useState(false);
  const contatos = Array.isArray(dados) ? dados : [];

  const handleExport = () => {
    if (!contatos.length) return;

    try {
      setLoading(true);

      // Mantem a planilha com colunas claras e na mesma ordem da tela de contatos.
      const linhas = contatos.map((contato) => ({
        Nome: contato.nome || "",
        Telefone: contato.telefone || "",
        Tipo: contato.tipo || "",
        Departamento: contato.departamento || "",
      }));
      const worksheet = XLSX.utils.json_to_sheet(linhas);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Contatos");

      XLSX.writeFile(workbook, "contatos.xlsx");
    } catch (error) {
      console.error("Erro ao exportar:", error);
    } finally {
      setLoading(false);
    }
  };

  // A largura acompanha o texto, mantendo icone e rotulo na mesma linha.
  return (
    <button
      type="button"
      onClick={handleExport}
      disabled={loading || contatos.length === 0}
      aria-label="Exportar contatos para Excel"
      title="Exportar contatos para Excel"
      className="flex h-12 shrink-0 flex-row items-center justify-center gap-2 whitespace-nowrap px-4 text-sm font-semibold rounded-md border border-black/10 dark:border-white/15 bg-white/85 dark:bg-zinc-800/85 text-[#B95758] dark:text-rose-300 shadow-sm backdrop-blur transition hover:bg-white dark:hover:bg-zinc-700 hover:text-[#9f3f40] dark:hover:text-rose-300 disabled:cursor-not-allowed disabled:opacity-60"
    >
      <Download className="h-6 w-6 shrink-0" strokeWidth={2.4} />
      Baixar Excel
    </button>
  );
}